import { render, staticRenderFns } from "./SchoolDataModal.vue?vue&type=template&id=60a0c44b&"
import script from "./SchoolDataModal.vue?vue&type=script&lang=js&"
export * from "./SchoolDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports